import Vue from 'vue'

import VueApexCharts from 'vue-apexcharts'
// import Apex from 'apexcharts'
Vue.component('apexchart', VueApexCharts)
